module.exports = __webpack_public_path__ + "img/helpbox-7.bc3e9634.png";